import 'reflect-metadata';
import './global-shim';

/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
import 'core-js/stable';  // Run `npm install --save classlist.js`.

/**
 * IE10 and IE11 requires the following for the Reflect API.
 * Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
 */
import 'core-js/es/reflect';

// For URL implementation polyfill
import 'core-js/stable/url';

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */
import 'zone.js';  // Included with Angular CLI.

(window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
(window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

/*
* in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
* with the following flag, it will bypass `zone.js` patch for IE/Edge
*/
(window as any).__Zone_enable_cross_context_check = true;

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
window['__Zone_disable_IE_check'] = true;

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

(window as any).ENV = {
  env: { DEBUG: undefined },
};

(window as any).process = {
  env: { DEBUG: undefined },
};

if (!Element.prototype.matches) {
  Element.prototype.matches = (Element.prototype as any).msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if ((window as any).NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = (Array.prototype.forEach as any);
}

if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    value(search, rawPos) {
      const pos = rawPos > 0 ? rawPos : 0;
      return this.substring(pos, pos + search.length) === search;
    }
  });
}

(() => {
  const setProtoOf = (obj: any, proto: any) => {
    obj.__proto__ = proto;
    return obj;
  };

  const mixinProperties = (obj: any, proto: any) => {
    for (const prop in proto) {
      if (!obj.hasOwnProperty(prop)) {
        obj[prop] = proto[prop];
      }
    }
    return obj;
  };

  Object.setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
})();

(<any>window).OPENED_WIN_STATES = new WeakMap<Window, any>();

// noop function is used in-place of an empty function usage across app
(<any>window).noop = (..._args: any[]): any => { /* do nothing function */ };
